document.addEventListener('DOMContentLoaded', function () {
  if (window.location.hash !== '#hay-fever') return;

  setTimeout(function () {
    const target = document.querySelector('.hay-fever-module');

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, 500);
});